import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

import { fetchEnumValues } from '@services/commonService';

const SalesChannel = () => {
	const [dataList, setDataList] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	useEffect(() => {
		(async () => {
			try {
				await fetchEnumValues('info.nitex.app.common.enums.OrderStream', setDataList);
			} catch {
				/* Empty Block */
			}
		})();
	}, []);

	const dispatch = useDispatch();

	const renderDataList = () => {
		return dataList?.map((item) => {
			return (
				<div className="form-group" key={`filter_streamList_${item.value}`}>
					<input
						type="checkbox"
						id={`streamList_${item.value}`}
						name={`streamList_${item.value}`}
						value={item.value}
						onChange={(e) => handleCheckbox(e, item.label)}
						checked={toggleCheckbox(
							filterData,
							'streamList',
							`streamList_${item.value}`,
							item.value
						)}
					/>
					<label htmlFor={`streamList_${item.value}`}>
						<span>{item.label}</span>
					</label>
				</div>
			);
		});
	};

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'streamList',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	return (
		<div className="card">
			<div className="card-header" id="streamHeading">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#streamList"
						aria-expanded="false"
						aria-controls="streamList"
					>
						Revenue Stream
					</button>
				</h5>
			</div>
			<div
				id="streamList"
				className="collapse"
				aria-labelledby="streamHeading"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="custom-chekbox">{renderDataList()}</div>
				</div>
			</div>
		</div>
	);
};

export default SalesChannel;
